import i18n from 'constants/strings'
import ModalWTN from 'components/generic/ModalWTN'
import { useModalDispatch } from 'hooks/use-modal'
import { useCallback } from 'react'
import { ProfileModalsState } from '../panels/MyScoresPanel'
import { ProfileModalId } from 'constants/modals'

const InfoPendingScoreModal = () => {
  const { modalDispatch, modalActions } = useModalDispatch<
    ProfileModalsState,
    ProfileModalId.INFO_PENDING_SCORE
  >(ProfileModalId.INFO_PENDING_SCORE)

  const handleCancel = useCallback(() => {
    modalDispatch(modalActions.closeModal())
  }, [modalDispatch, modalActions])

  return (
    <ModalWTN
      modalId={ProfileModalId.INFO_PENDING_SCORE}
      widgetElId='player-profile'
      textHeader={i18n.t('strSocialMatches.modals.infoPending.header')}
      btnAlignment='right'
      btnSecondary={{
        text: i18n.t('strCommonUI.button.close'),
        onClick: handleCancel,
      }}
    >
      <p>{i18n.t('strSocialMatches.modals.infoPending.info.1')}</p>
      <p style={{ margin: '0' }}>{i18n.t('strSocialMatches.modals.infoPending.info.2')}</p>
    </ModalWTN>
  )
}

export default InfoPendingScoreModal
